
import { Datagrid, List, TextField } from "react-admin";

export const ProductsList = (props: any) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="name" label="Nome" />
      <TextField source="category" label="Categoria" />
    </Datagrid>
  </List>
);
